import "./index.scss";
// import { $ } from "@olmokit/dom";

/**
 * Component: CategoryMenu
 */
export function CategoryMenu() {
  console.log("CategoryMenu mounted.");
}
